import { render } from "./Prenotazioni.vue?vue&type=template&id=176f1722"
import script from "./Prenotazioni.vue?vue&type=script&lang=js"
export * from "./Prenotazioni.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__